var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74805 12.0051H6.37305C5.5774 12.0051 4.81434 12.3211 4.25173 12.8838C3.68912 13.4464 3.37305 14.2094 3.37305 15.0051V16.5051M17.1566 13.2246C17.4553 12.9258 17.6232 12.5206 17.6232 12.0981C17.6232 11.6756 17.4553 11.2703 17.1566 10.9716C16.8578 10.6728 16.4526 10.505 16.0301 10.505C15.6075 10.505 15.2023 10.6728 14.9036 10.9716L11.8961 13.9806C11.7177 14.1588 11.5872 14.3791 11.5166 14.6211L10.8888 16.7736C10.87 16.8381 10.8689 16.9065 10.8855 16.9716C10.9022 17.0368 10.9361 17.0962 10.9836 17.1437C11.0312 17.1913 11.0906 17.2252 11.1557 17.2418C11.2209 17.2585 11.2893 17.2574 11.3538 17.2386L13.5063 16.6108C13.7483 16.5402 13.9686 16.4096 14.1468 16.2313L17.1566 13.2246ZM11.6231 6.00508C11.6231 7.66193 10.2799 9.00508 8.62305 9.00508C6.9662 9.00508 5.62305 7.66193 5.62305 6.00508C5.62305 4.34822 6.9662 3.00508 8.62305 3.00508C10.2799 3.00508 11.6231 4.34822 11.6231 6.00508Z",
    stroke: "#131518",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d95e635b0f98ae506b52b15ab1324e7d.svg";
export { ForwardRef as ReactComponent };